import { createFileRoute } from "@tanstack/react-router";

import ProjectDashboard from "~/pages/RecordLabelling/ProjectDashboard";
import { ROUTE_STATIC } from "~/utils/routeStaticData";

export const Route = createFileRoute(
  "/_private/record-labelling-admin/projects/$id/",
)({
  staticData: ROUTE_STATIC.recordLabellingAdmin,
  component: ProjectDashboard,
});
